
        module.exports = __webpack_public_path__ + "assets/images/bizffwd-text-white.06160042.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 548,
            height: 96,
            type: "svg",
            bytes: 1293,

            toString: function() {
                return src;
            }
        };
    